/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import ProductFilter from './filter/ProductFilter';
import ProductTable from './table/ProductTable';
import './styles.scss';
import { useAppContext } from 'providers/AppProvider';
import ButtonRefresh from 'components/base/ButtonRefresh';
import queryClient from 'service/queryClient';

export const productBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'reports',
    url: '/reports/purchase/invoice'
  },
  {
    label: 'sale',
    url: '/reports/sale/payments'
  },

  {
    label: 'sales_product',
    active: true
  }
];

const ByProduct = () => {
  const { t, i18n } = useTranslation();
  const {
    config: { theme }
  } = useAppContext();

  const barcodeInputRef = useRef<HTMLInputElement>(null);

  const [generateTableData, setGeneratedTableData] = useState([]);
  const [savedValues, setSavedValues] = useState([]);
  const [getName, setGetName] = useState('');
  const [getBarcode, setGetBarcode] = useState('');
  const [getFilterData, setGetFilterData] = useState({});
  const [debouncedBarcode, setDebouncedBarcode] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalAmount, setTotalAmount] = useState([]);
  const [labeledVisibleFields, setLabeledVisibleFields] = useState<any>('');

  useEffect(() => {
    if (barcodeInputRef.current) {
      barcodeInputRef.current.focus();
      setTimeout(() => barcodeInputRef.current?.select(), 500);
    }
  }, []);

  return (
    <div>
      <PageBreadcrumb items={productBreadcrumbItems} />
      <div>
        <div className="mb-5 d-flex gap-2 align-items-center">
          <h2>{t('sales_product')}</h2>
          <ButtonRefresh
            onRefresh={() => {
              queryClient.refetchQueries('GET_REPORTS_SALE');
            }}
          />
        </div>

        <ProductFilter
          setGeneratedTableData={setGeneratedTableData}
          savedValues={savedValues}
          setSavedValues={setSavedValues}
          setGetName={setGetName}
          setGetBarcode={setGetBarcode}
          getName={getName}
          getBarcode={getBarcode}
          setGetFilterData={setGetFilterData}
          getFilterData={getFilterData}
          barcodeInputRef={barcodeInputRef}
          setDebouncedBarcode={setDebouncedBarcode}
          currentPage={currentPage}
          setPageCount={setPageCount}
          setCurrentPage={setCurrentPage}
          setTotalAmount={setTotalAmount}
          labeledVisibleFields={labeledVisibleFields}
        />
        <ProductTable
          generateTableData={generateTableData}
          setGeneratedTableData={setGeneratedTableData}
          getName={getName}
          getBarcode={getBarcode}
          getFilterData={getFilterData}
          barcodeInputRef={barcodeInputRef}
          debouncedBarcode={debouncedBarcode}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageCount={pageCount}
          setPageCount={setPageCount}
          setTotalAmount={setTotalAmount}
          setLabeledVisibleFields={setLabeledVisibleFields}
        />

        <div
          className={theme === 'dark' ? 'dark-footer-bypro' : 'footer-bypro'}
        >
          {totalAmount && (
            <div className="box d-flex gap-2 flex-column">
              {totalAmount
                ?.filter((item: any) => item?.currency_id)
                .map((items: any) => (
                  <div key={items} className="d-flex gap-2">
                    <p className="mb-0" style={{ fontWeight: '800' }}>
                      {t('total_amount')}: (
                      {items?.currency?.name?.[i18n?.language]})
                    </p>
                    <span style={{ fontWeight: '800' }}>
                      {items?.total_price_amount
                        ? new Intl.NumberFormat('en-US', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 4,
                            useGrouping: true
                          })
                            .format(items?.total_price_amount)
                            .replace(/,/g, ' ')
                        : 0}
                    </span>
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ByProduct;
